export const migrate = {
  init(config?: any, tenantCode?: string, _serviceCallEnv?: string) { },
  setStoreInfo(storeInfo: StoreInfo, uiConfig?: MigrateUIConfig) { },
  getStoreInfo() { },
  setPermCodes(permCodes: []) { },
  getPermCodes() { },
  setUserInfo(userInfo: UserInfo) { },
  getUserInfo() { },
  getMode() { },
  syncData() { },
  uploadModelLog(isOff: boolean) { },
  isUploadModelLog() { },
  setMigrateUIConfig(config: MigrateUIConfig) { },
  forceRequestRemote(isOff: boolean) { },
  isForceRequestRemote() { },
  getAppInfo() { },
  setConfig() { },
}
